export const isFullStatic = false
export const staticPath = "/app/.nuxt/static-json"
export const publicPath = "https://prod-eks-catalog.s3.us-east-2.amazonaws.com/f571f40/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"